import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import type { HierarchyDTO } from './useGetHierarchies';

export const useGetHierarchy = (hierarchyId: string, options: { enabled?: boolean } = {}) => {
	return useQuery({
		queryKey: ['hierarchy', hierarchyId],
		enabled: options.enabled ?? !!hierarchyId,
		queryFn: async () => {
			const { data } = await api.get<HierarchyDTO>(`/hierarchy/get/${hierarchyId}`);
			return data;
		},
	});
};
